import { useEffect, useState } from 'react'
import Uppy from '@uppy/core'
import XHRUpload from '@uppy/xhr-upload'

import useThunkDispatch from 'hooks/useThunkDispatch'

import { addImage } from 'agency/redux/modules/image'
import { addUserImage } from 'agency/redux/modules/user'

const csrfToken = document.querySelector('meta[name="csrf-token"]').content

const initializeUppy = (options, dispatch) => {
  const {
    allowedFileTypes,
    endpoint,
    fieldName,
    image_type,
    imageable_id,
    imageable_type,
    requestOptions = {},
  } = options

  const uppy = new Uppy({
    debug: false,
    autoProceed: true,
    method: 'post',
    restrictions: {
      allowedFileTypes: allowedFileTypes ? allowedFileTypes.split(',') : ['image/*'],
    },
  })
    .use(XHRUpload, {
      endpoint,
      method: 'POST',
      headers: {
        'X-CSRF-Token': `${csrfToken}`,
      },
      formData: true,
      fieldName: fieldName || 'image[file]',
      getResponseError(responseText){
        return new Error(JSON.parse(responseText).message)
      },
    })
    .on('file-added', (file) => {
      uppy.setFileMeta(file.id, {
        'image[imageable_type]': imageable_type,
        'image[imageable_id]': imageable_id,
        'image[image_type]': image_type || 'photo',
        v2: true,
        ...requestOptions,
      })
    })
    .on('upload-success', (_, response) => {
      const { body: image } = response

      if (image.imageable_type === 'User'){
        dispatch(addUserImage(image))
      } else {
        dispatch(addImage(image))
      }
    })

  return uppy
}

const checkRequiredOptions = (options = {}) => {
  const requiredOptions = ['endpoint', 'imageable_type', 'imageable_id']
  const optionKeys = Object.keys(options)

  return requiredOptions.every(key => optionKeys.includes(key))
}

function useUppyImageUpload(options = {}, deps = []){
  const [uppy, setUppy] = useState(undefined)

  const dispatch = useThunkDispatch()

  useEffect(() => {
    if (checkRequiredOptions(options)){
      return setUppy(initializeUppy(options, dispatch))
    }

    return () => {
      if (uppy){
        uppy.close()
        setUppy(undefined)
      }
    }
  }, [...deps])

  return uppy
}

export default useUppyImageUpload
